module.exports = "/images/app-store.png";